import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

const ExportDatasetModalHeader = () => (
    <Box>
        <Typography id="modal-modal-title" variant="h6" component="h2">
            <FormattedMessage id="exportToTPS" />
        </Typography>
        <Typography variant="body2">
            <FormattedMessage id="exportToTPSDescription" />
        </Typography>
    </Box>
);

export default ExportDatasetModalHeader;
